export var getIsValueEqual = function getIsValueEqual() {
  var valueArrayOne = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var valueArrayTwo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return valueArrayOne.length === valueArrayTwo.length && valueArrayOne.reduce(function (accumulator, item, index) {
    return accumulator && item === valueArrayTwo[index];
  }, true);
};